<template>
  <van-uploader
    v-model="fileList"
    accept=""
    :after-read="afterRead"
    :max-count="maxCount"
    :max-size="maxSize"
    multiple
    name="FormFile"
    @oversize="onOversize"
  >
    <div class="uploader_box">
      <van-icon color="#dcdee0" name="column" size="24" />
      <p>上传文件</p>
    </div>
  </van-uploader>
</template>
<script>
  import { onMounted, reactive, ref, toRefs, watch } from 'vue'
  import axios from 'axios'
  import store from '@/store'
  import api from '@/api'
  import { Notify, Toast, Uploader } from 'vant'
  import { getCompressImage } from '@/utils'
  export default {
    props: {
      file: {
        type: Array,
        default() {
          return []
        },
      },
      maxCount: {
        type: Number,
        default: 9,
      },
      maxSize: {
        type: Number,
        default: 10 * 1024 * 1024,
      },
      // 压缩至M图片
      limitSize: {
        type: Number,
        default: 500 * 1024 * 1024,
      },
    },
    setup(props, ctx) {
      const fileList = ref([])
      const name = ref([])
      const { file } = toRefs(props)
      const init = ref(false)

      const fileInit = (val) => {
        if (val) {
          const arr = []
          val.forEach((item) => {
            arr.push({
              url: api.FileHost + item.DeliveryUrl,
              status: 'success',
              backUrl: item.DeliveryUrl,
              name: item.DeliveryName,
            })
          })
          fileList.value = arr
        }
      }
      // UploadAttachment

      watch(file, (newVal) => {
        fileInit(newVal)
      })

      const afterRead = (file) => {
        if (Array.isArray(file)) {
          file.forEach((item) => {
            upload(item)
          })
        } else {
          upload(file)
        }
      }

      const onOversize = (file) => {
        const size = props.maxSize / (1024 * 1024)
        Notify({ type: 'danger', message: `文件大小超过最大${size}M限制` })
      }

      const callback = () => {
        const list = []
        let allUploadDone = true
        fileList.value.forEach((item) => {
          if (item.status != 'success') {
            allUploadDone = false
          }
          list.push({
            DeliveryUrl: item.backUrl,
            DeliveryName: item.name || (item.file && item.file.name),
          })
        })
        // 当存在同时上传多个文件时 等待全部上传完
        if (allUploadDone) {
          ctx.emit('update:file', list)
        }
      }

      const upload = async (file) => {
        file.status = 'uploading'
        file.message = '上传中...'
        const param = new FormData()
        param.append('formFile', file.file)
        const token = store.getters['user/token']
        axios({
          method: 'POST',
          url: api.UploadAttachment,
          data: param,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(({ data }) => {
            if (data.Code === 0) {
              file.backUrl = data.Data
              file.status = 'success'
              file.message = '上传成功'
              callback()
            } else {
              file.status = 'failed'
              file.message = '上传失败'
              Notify({ type: 'danger', message: data.Message })
            }
          })
          .catch((e) => {
            file.status = 'failed'
            file.message = '上传失败'
            Notify({ type: 'danger', message: '上传失败' + e.Message })
          })
      }

      return {
        fileList,
        afterRead,
        onOversize,
        name,
      }
    },
  }
</script>

<style scoped lang="scss">
  .uploader_box {
    width: 80px;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin-bottom: 15px;
    img {
      width: 20px;
    }
    p {
      font-size: 12px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      color: #a5a5a6;
    }
  }
</style>
